const STORAGE_KEY = "locale"

// Jedno źródło prawdy dla listy języków — Header renderuje z tego dropdown,
// a walidacja zapisanej wartości nie przepuści czegoś, czego nie ma na liście.
export const LOCALES = [
  { value: "pl", label: "Polski" },
  { value: "en", label: "English" },
  { value: "sk", label: "Slovenčina" },
  { value: "de", label: "Deutsch" },
]

function isSupported(locale) {
  return LOCALES.some((lang) => lang.value === locale)
}

// Zwraca język wybrany ręcznie przez użytkownika albo null, jeśli jeszcze nic nie wybrał.
export function readSavedLocale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return isSupported(stored) ? stored : null
  } catch (error) {
    // Brak dostępu do localStorage (tryb prywatny) — lecimy na domyślnym języku.
    return null
  }
}

export function hasSavedLocale() {
  return readSavedLocale() !== null
}

// Wołane tylko przy świadomym wyborze z menu — języka narzuconego przez zawody nie zapisujemy.
export function saveLocale(locale) {
  if (!isSupported(locale)) return

  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch (error) {
    // Zapis się nie udał — wybór zadziała do końca sesji.
  }
}
